//==== REGEXES THAT MAY COME IN HANDY WHEN PARSING OTHER 
// //$2 - pluginName
// const pluginNameRegex = /(?:^|\s)[Nn]ame=(['"])([^'"]+)\1/;

// //$1 - configs tag content
// const configsTagRegex = /<Configs>([\s\S]*?)<\/Configs>/;

// //$1 - sites tag content
// const sitesTagRegex = /<Sites>([\s\S]*?)<\/Sites>/;

// const defsitesId = /<Site[^\/>]*?\sDefSiteId=(['"])([^'"]+)\1\/>/g;



//$1 - plugins tag content
const pluginsTagRegex = /<Plugins>([\s\S]*?)<\/Plugins>/;

//$1 - plugin args
//$2 - plugin tag content
const pluginTagRegex = /<Plugin\s+([^>]+)>([\s\S]+?)<\/Plugin>/g;

//$2 - pluginName
const pluginNameRegex = /(?:\s|^)Name=(['"])([^'"]+)\1/;

//$2 - pluginId
const pluginIdRegex = /(?:\s|^)[pP]luginId=(['"])([^'"]+)\1/;


//$1 - config tag content
const configTagRegex = /<Config>([\s\S]*?)<\/Config>/;


/**
 * Parses plugin ids and configs
 * Returns map<pluginId,configJson>
 * @param {string} xmlString 
 */
export function getPluginConfigMaps(xmlString) {
    const map = new Map();
    const pluginsContent = pluginsTagRegex.exec(xmlString)[1];
    if (!pluginsContent) {
        console.warn('No <Plugins> tag, returning empty map of plugin');
        return map;
    }
    let pluginMatch;
    const maxRecObjectId = {};

    while ((pluginMatch = pluginTagRegex.exec(pluginsContent)) !== null) {
        //if no args or if no plugin content)
        if (!pluginMatch[1] || !pluginMatch[2]) {
            continue;
        }
        const nameMatch = pluginNameRegex.exec(pluginMatch[1]);
        const configMatch = configTagRegex.exec(pluginMatch[2]);
        //if plugin has no config or has no id
        if (!configMatch || !nameMatch) {
            continue;
        }
        const pluginName = nameMatch[2];
        const pluginConfig = configMatch[1];
        map.set(pluginName, pluginConfig);
        const pluginId = parsePluginId(pluginMatch[1]);

        const recIdObject = parseRecObjectId(pluginId,pluginName);
        checkForNewMaxRecommendedId(recIdObject, maxRecObjectId);
    }
    this.counter = {...this.counter, ...maxRecObjectId};
    return map;
}

function checkForNewMaxRecommendedId(recIdObject, maxRecObjectId) {
    if (recIdObject) {
        const name = recIdObject.name;
        const id = recIdObject.id;
        if (!maxRecObjectId[name]) {
            maxRecObjectId[name] = 0;
        }
        if (maxRecObjectId[name] <= id) {
            maxRecObjectId[name] = id + 1;
        }
    }
}

function parseRecObjectId(pluginId, pluginName) {
    if(pluginId !== "1") {
        return null;
    }
    const match = /^([-A-Za-z]+)-(\d+)$/.exec(pluginName);
    if(!match) {
        return null;
    }
    return {
        name: match[1],
        id: parseInt(match[2],10),
    }
}
function parsePluginId(pluginTagArgs){
    const pluginIdMatch = pluginIdRegex.exec(pluginTagArgs);
    if(!pluginIdMatch?.[2]) {
        return null;
    }
    const pluginId = pluginIdMatch[2];
    return pluginId;
}